import { createSlice } from '@reduxjs/toolkit';
import {
  handleResetFilter,
  handleSetSelectedFilterValue,
  handleToggleCollapsed,
  handleChangeSortBy,
  handleSetSelectedFilterIds,
  handleSetSelectedContentBasedValues,
  handleSetSelectedCategories,
} from 'store/helpers/filterHelpers';
import { multiPlatformFiltersInitialState } from './initialState/multiPlatformInitialState';
import { handleApplySettingsFilters } from './contentHelpers';

export { multiPlatformFiltersInitialState as filtersInitialState };
export const multPlatformContentInitialState = {
  filters: multiPlatformFiltersInitialState,
  sortBy: {
    selected: 'time',
    order: 'desc',
  },
  selectedFilter: 'contentTagFilter',
};
export const multiPlatformContentSlice = createSlice({
  name: 'multiPlatformContentSlice',
  initialState: multPlatformContentInitialState,
  reducers: {
    setSelectedFilterIds: (state, action) => {
      handleSetSelectedFilterIds(state, action);
    },
    setSelectedFilterValue: (state, action) => {
      handleSetSelectedFilterValue(
        state,
        action,
        multiPlatformFiltersInitialState
      );
    },
    setSelectedContentBasedValues: (state, action) => {
      handleSetSelectedContentBasedValues(state, action);
    },
    setSelectedCategories: (state, action) => {
      handleSetSelectedCategories(state, action);
    },
    changeSortBy: (state, action) => {
      handleChangeSortBy(state, action);
    },
    toggleCollapsed: (state, action) => {
      handleToggleCollapsed(state, action);
    },
    resetAllFilters: (state) => {
      state.filters = multiPlatformFiltersInitialState;
    },
    resetFilter: (state, action) => {
      handleResetFilter(state, action, multiPlatformFiltersInitialState);
    },
    setSelectedFilter: (state, action) => {
      state.selectedFilter = action.payload;
    },
    applyWebsiteSettingsFilters: (state, action) => {
      handleApplySettingsFilters(state, action);
    },
  },
});

export const {
  toggleCollapsed,
  resetAllFilters,
  resetFilter,
  setSelectedFilterValue,
  setSelectedFilterIds,
  setSelectedContentBasedValues,
  setSelectedCategories,
  changeSortBy,
  setSelectedFilter,
  applyWebsiteSettingsFilters,
} = multiPlatformContentSlice.actions;
